import React from "react";

const NoticeIcon = ({ size = 24, className = "", active = false }) => {
  const iconSize = size;
  
  return (
    <svg 
      width={iconSize} 
      height={iconSize} 
      viewBox="0 0 56 56" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M28 1C42.9117 1 55 13.0883 55 28C55 42.9117 42.9117 55 28 55C13.0883 55 1 42.9117 1 28C1 13.0883 13.0883 1 28 1Z" 
        fill={active ? "#3B82F6" : "#9EA6B2"} 
        fillOpacity={active ? "0.3" : "0.3"}
      />
      <path 
        d="M28 1C42.9117 1 55 13.0883 55 28C55 42.9117 42.9117 55 28 55C13.0883 55 1 42.9117 1 28C1 13.0883 13.0883 1 28 1Z" 
        stroke={active ? "#3B82F6" : "url(#paint0_linear_2064_9436)"} 
        strokeWidth="2"
      />
      <g clipPath="url(#clip0_2064_9436)">
        <path 
          d="M30.5781 16H26.4219C25.7647 16 25.1305 16.2448 24.6407 16.6876C24.1508 17.1303 23.8396 17.74 23.7666 18.4H21.6719C20.9632 18.4 20.2836 18.6845 19.7826 19.1908C19.2815 19.6972 19 20.3839 19 21.1V37.3C19 38.0161 19.2815 38.7028 19.7826 39.2092C20.2836 39.7155 20.9632 40 21.6719 40H35.3281C35.679 40 36.0264 39.9302 36.3506 39.7945C36.6748 39.6588 36.9693 39.4599 37.2174 39.2092C37.4655 38.9585 37.6623 38.6608 37.7966 38.3332C37.9309 38.0057 38 37.6546 38 37.3V21.1C38 20.7454 37.9309 20.3943 37.7966 20.0668C37.6623 19.7392 37.4655 19.4415 37.2174 19.1908C36.9693 18.9401 36.6748 18.7412 36.3506 18.6055C36.0264 18.4698 35.679 18.4 35.3281 18.4H33.2334C33.1604 17.74 32.8492 17.1303 32.3593 16.6876C31.8695 16.2448 31.2353 16 30.5781 16ZM26.4219 17.8H30.5781C30.8143 17.8 31.0409 17.8948 31.2079 18.0636C31.3749 18.2324 31.4688 18.4613 31.4688 18.7C31.4688 18.9387 31.3749 19.1676 31.2079 19.3364C31.0409 19.5052 30.8143 19.6 30.5781 19.6H26.4219C26.1857 19.6 25.9591 19.5052 25.7921 19.3364C25.6251 19.1676 25.5312 18.9387 25.5312 18.7C25.5312 18.4613 25.6251 18.2324 25.7921 18.0636C25.9591 17.8948 26.1857 17.8 26.4219 17.8ZM34.4731 26.836L27.9419 33.436C27.7749 33.6045 27.5485 33.6992 27.3125 33.6992C27.0765 33.6992 26.8501 33.6045 26.6831 33.436L23.7144 30.436C23.6269 30.3536 23.5567 30.2542 23.508 30.1438C23.4593 30.0334 23.4332 29.9143 23.431 29.7934C23.4289 29.6726 23.4509 29.5525 23.4957 29.4405C23.5405 29.3284 23.6072 29.2266 23.6918 29.1412C23.7763 29.0557 23.8771 28.9883 23.988 28.9431C24.0989 28.8978 24.2177 28.8756 24.3372 28.8777C24.4568 28.8798 24.5748 28.9063 24.684 28.9555C24.7933 29.0047 24.8916 29.0756 24.9731 29.164L27.3125 31.528L33.2144 25.564C33.2959 25.4756 33.3942 25.4047 33.5035 25.3555C33.6127 25.3063 33.7307 25.2798 33.8503 25.2777C33.9698 25.2756 34.0886 25.2978 34.1995 25.3431C34.3104 25.3883 34.4112 25.4557 34.4957 25.5412C34.5803 25.6266 34.647 25.7284 34.6918 25.8405C34.7366 25.9525 34.7586 26.0726 34.7565 26.1934C34.7543 26.3143 34.7282 26.4334 34.6795 26.5438C34.6308 26.6542 34.5606 26.7536 34.4731 26.836Z" 
          fill="white"
        />
      </g>
      <defs>
        <linearGradient 
          id="paint0_linear_2064_9436" 
          x1="3.95297" 
          y1="4.40429" 
          x2="50.7637" 
          y2="54.4557" 
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <clipPath id="clip0_2064_9436">
          <rect width="24" height="24" fill="white" transform="translate(16 16)"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoticeIcon; 